import { api } from "@/services/api"
import type { MerchantCurrencyCode } from "@/utils/currency"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

export type TopScoringMerchant = {
  id: number
  merchantName: string
  tpReference: string
  totalTransactions: number | null
  engagementScore: number | null
  currency: MerchantCurrencyCode
}

export type TopScoringMerchantFilter = {
  forMonthStartingOn: string
  currency: MerchantCurrencyCode
}

type TopScoringMerchantSorting =
  | "totalTransactions"
  | "-totalTransactions"
  | "enagementScore"
  | "-engagementScore"

type TopScoringMerchantQuery = TopScoringMerchantFilter & {
  ordering?: TopScoringMerchantSorting
} & Pagination

export const listTopScoringMerchants = async (
  query: TopScoringMerchantQuery
) => {
  const { body } = await api.get<
    Paginate<TopScoringMerchant[]>
  >("/engagement/top-scorers/", {
    query: query,
  })

  return body
}

export const useTopScoringMerchants = (
  query: MaybeRef<TopScoringMerchantQuery>,
  enabled: MaybeRef<boolean> = true
) =>
  useQuery({
    queryKey: [
      TOP_SCORING_MERCHANTS_QUERY_KEY,
      query,
    ] as const,
    enabled,
    queryFn: ({ queryKey: [_, query_] }) =>
      listTopScoringMerchants(unref(query_)),
  })
